import CryptoJS from "crypto-js";

export function generateFileVersionId(fileId) {
  const timestamp = new Date().getTime();
  const uniqueInput = `${fileId}-${timestamp}`;
  const hash = CryptoJS.SHA256(uniqueInput).toString(CryptoJS.enc.Hex);
  return hash;
}
